import { services, siteConfig } from '@/mocks/data';

export default function ServicesSection() {
  const getWhatsappHref = (message: string) =>
    `https://wa.me/${siteConfig.whatsappNumber}?text=${encodeURIComponent(message)}`;

  return (
    <section className="py-16 md:py-20 bg-background-100">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <h2 className="font-heading text-2xl md:text-4xl text-foreground-900 mb-4">Hizmetlerimiz</h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8">
          {services.map((service) => (
            <div
              key={service.id}
              className="bg-background-50 rounded-lg p-6 md:p-8 border border-background-200/70 flex flex-col"
            >
              <div className="w-14 h-14 rounded-lg bg-primary-100 flex items-center justify-center mb-5">
                <i className={`${service.icon} text-primary-600 text-2xl w-7 h-7 flex items-center justify-center`}></i>
              </div>
              <h3 className="font-heading text-lg text-foreground-900 mb-3">{service.title}</h3>
              <p className="text-foreground-600 text-sm leading-relaxed mb-6 flex-1">
                {service.description}
              </p>
              <a
                href={getWhatsappHref(service.whatsappMessage)}
                target="_blank"
                rel="noopener noreferrer"
                className="inline-flex items-center justify-center gap-2 bg-primary-500 text-background-50 px-5 py-2.5 rounded-md text-sm font-medium hover:bg-primary-600 transition-colors whitespace-nowrap mt-auto"
              >
                <i className="ri-whatsapp-line w-4 h-4 flex items-center justify-center"></i>
                {service.title.includes('Isı Pompası') ? 'Isı Pompası Bilgisi Al' : service.title.includes('Kat Kaloriferi') ? 'Kat Kaloriferi İçin Bilgi Al' : 'Güneş Enerjisi Bilgisi Al'}
              </a>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}